module.exports = __webpack_public_path__ + "static/media/2_deux_a.011ab3fc.ogg";